(function() {
    'use strict';

    angular
        .module('askApp')
        .factory('DinghySearch', DinghySearch);

    DinghySearch.$inject = ['$resource'];

    function DinghySearch($resource) {
        var resourceUrl =  'api/_search/dinghies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
